import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { createCampaign } from '../api/campaigns';
import type { CampaignFormValues } from '../types';
import { notification } from 'antd';

export function useCreateCampaign(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CampaignFormValues) => createCampaign(data),
    onSuccess: () => {
      notification.success({ message: 'Campaign created successfully' });
      invalidateListResource(queryClient, 'campaigns');
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to create campaign' });
    },
  });
}
